import { PreProjetoModel } from './../PreProjeto/Model';
import { MonografiaModel } from './../Monografia/Model';
import { observable } from 'mobx';

export enum TipoProfessor {
    Contratado,
    Titular,
    Externo
}

export class ProfessorModel {
    @observable public id: number = 0;
    @observable public nome: string = '';
    @observable public cpf: string = '';
    @observable public telefone: string | null = '';
    @observable public email: string = '';
    @observable public vagasPreProjeto: number = 0;
    @observable public tipo: TipoProfessor = TipoProfessor.Contratado;
    @observable public ativo: boolean = true;
    @observable public ativoBanca: boolean = true;
}

export class ProfessorComMonoEPreModel {
    @observable public professor: ProfessorModel
    @observable public monografias: MonografiaModel[]
    @observable public preProjetos: PreProjetoModel[]
}